const MAX_ENTRIES = 12;
const MAX_RECENT = 24;

/** Shared across sidebar/studio remounts; failures are cached too, so an older
 *  API or unavailable model does not get hammered by opening the panel. */
export function createSuggestionCache() {
  const requests = new Map<string, Promise<string[]>>();
  let recent: string[] = [];
  return {
    get(key: string, load: (previous: string[]) => Promise<string[]>): Promise<string[]> {
      const existing = requests.get(key);
      if (existing) return existing;
      const request = Promise.resolve().then(() => load([...recent])).then((raw) => {
        const suggestions = Array.isArray(raw) ? [...new Set(raw.filter((value) => (
          typeof value === 'string' && value.trim().length > 0 && value.length <= 180
        )).map((value) => value.trim()))].slice(0, 3) : [];
        recent = [...recent, ...suggestions].slice(-MAX_RECENT);
        return suggestions;
      }).catch(() => []);
      requests.set(key, request);
      if (requests.size > MAX_ENTRIES) requests.delete(requests.keys().next().value!);
      return request;
    },
  };
}
